import { jsx as t } from "react/jsx-runtime";
import { useRef as c, useEffect as u } from "react";
import m from "../Button/index.js";
import i from "../../icons/Dropup.js";
const a = "forma-ui__scroll-to-top-button__root", d = "forma-ui__scroll-to-top-button__button", n = {
  root: a,
  button: d
}, h = () => {
  const o = c(null);
  u(() => {
    const r = () => {
      var e, s;
      document.documentElement.scrollTop > 300 ? (e = o.current) == null || e.classList.add("show") : (s = o.current) == null || s.classList.remove("show");
    };
    return document.addEventListener("scroll", r), () => document.removeEventListener("scroll", r);
  }, []);
  const l = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  return /* @__PURE__ */ t("div", { className: n.root, ref: o, children: /* @__PURE__ */ t(
    m,
    {
      className: n.button,
      viewStyle: "secondary",
      icon: /* @__PURE__ */ t(i, {}),
      onClick: l,
      shadow: !0
    }
  ) });
};
export {
  h as default
};
